import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-hrm-breadcrumb',
  templateUrl: './hrm-breadcrumb.component.html',
  styleUrls: ['./hrm-breadcrumb.component.css'],
})
export class HrmBreadCrumbComponent {
  @Input() items: HrmBreadcrumb[] = [];
  @Input() displayTitle = true;
  @Input() title = '';

  get pageTitle(): string {
    const t = this.title?.trim();
    if (t) {
      return t;
    }
    const last = this.items?.[this.items.length - 1];
    return last?.label?.trim() ?? '';
  }
}

export interface HrmBreadcrumb {
  label?: string,
  routerLink?: string
}
